export default "__VITE_PUBLIC_ASSET__0f810c65__"